const GRADIENT = `linear-gradient`;

export const allColors = {
  white: '#FFFFFF',
  black: '#000000',
  lightblack: '#333333',
  gray: '#999999',
  bannerRed: '#EB5757',
  //  Blue gradient

  blue: '#1676F3',
  bluegradient: `${GRADIENT}(180deg,#5418D1 0.42%,#2C88FF 79.92%)`,
  tertiaryblue: '#F4F9FF',

  // Orange gradient

  orange: '#FF9000',
  orangegradient: `${GRADIENT}(138deg, #E96263 12.32%, #EAAE4C 98.22%)`,
  tertiaryorange: '#FFF6EA',

  // Pink gradient

  pink: '#F72585',
  pinkgradient: `${GRADIENT}(135deg, #F97794 0%, #623AA2 100%)`,
  tertiarypink: '#FEE9F3',

  // Violet gradient

  violet: '#6026A8',
  violetgradient: `${GRADIENT}(226deg, #B66EC0 -12.73%, #460FA1 104.66%)`,
  tertiaryviolet: '#F5F2FA',

  // Teal gradient

  teal: '#46A9A9',
  tealgradient: `${GRADIENT}(135deg, #0E5CAD 0%, #79F1A4 100%)`,
  tertiaryteal: '#F4FAFA',

  //Red solid

  red: '#F41828',
  tertiaryred: '#FFF2F3',

  // Green

  green: '#8ECE19',
  tertiarygreen: '#F4FAFA',

  //Maroon solid

  rust: '#9B2226',
  tertiaryrust: '#FFF0F0',

  //Purple solid

  purple: '#6269C9',
  tertiarypurple: '#F4F6FF',

  //Golden gradient

  golden: `#F2BA35`,
  goldengradient: `${GRADIENT}(180deg, #F0EA88 0%, #CFA749 99.48%)`,

  //light green gradient

  lightgreen: `#D6E359`,
  lightgreengradient: `${GRADIENT}(180deg, #D6E359 0%, #9DB545 100%)`,

  //light blue gradient

  lightblue: `#A8EDF8`,
  lightbluegradient: `${GRADIENT}(90deg, #A8EDF8 0.29%, #5EC9E1 97.33%)`,

  skyblue: '#00ADE7',
  tertiaryskyblue: '#F2FCFF'
};
